import {ActionsBase, DispatchAll, IncludeResultCallbacks} from '@store/@types/alt';
import generateAsyncActions from 'utils/generateAsyncActions';
import {
  RecallZoomIntegrationSource,
  ZoomNoteTakerStateResponse,
} from '@store/recall/RecallZoomIntegrationSource';
import alt from 'components/Dispatcher';

interface AsyncActions {
  fetchRecallZoomState(): Promise<ZoomNoteTakerStateResponse>;
}

interface SyncActions {}

export interface RecallZoomIntegrationActionsInterface
  extends IncludeResultCallbacks<AsyncActions> {}

class RecallZoomIntegrationActions
  extends ActionsBase<AsyncActions, SyncActions>()
  implements DispatchAll<AsyncActions>
{
  constructor() {
    super();
    this.generateActions(...generateAsyncActions<AsyncActions>('fetchRecallZoomState'));
  }

  fetchRecallZoomState() {
    return dispatch => {
      dispatch();
      RecallZoomIntegrationSource.fetchRecallZoomState().then(
        this.fetchRecallZoomStateSuccess,
        this.fetchRecallZoomStateError
      );
    };
  }
}

export default alt.createActions<AsyncActions, SyncActions>(RecallZoomIntegrationActions);
